import { getOutlookWebHost } from '../../../utils/microsoftAccount';
import type { CreatedCalendarEvent } from '../../ScheduleMeetingModal/types';

type RedirectCalendarEvent = Pick<CreatedCalendarEvent, 'id'> &
  Partial<Omit<CreatedCalendarEvent, 'id'>>;

const translateMicrosoftRestIdToOwaId = async (
  eventId: string,
  microsoftAccessToken: string,
): Promise<string | null> => {
  try {
    const response = await fetch('https://graph.microsoft.com/v1.0/me/translateExchangeIds', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${microsoftAccessToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        inputIds: [eventId],
        sourceIdType: 'restId',
        targetIdType: 'restImmutableEntryId',
        // targetIdType: 'owaId',
      }),
    });

    if (!response.ok) {
      return null;
    }

    const json = (await response.json()) as {
      value?: Array<{ targetId?: string }>;
    };
    return json.value?.[0]?.targetId ?? null;
  } catch {
    return null;
  }
};

export const redirectToCalendarEdit = (
  event: RedirectCalendarEvent,
  microsoftAccessToken?: string,
  microsoftEmail?: string | null,
) => {
  let url = '';

  if (event?.provider === 'google' && event.htmlLink) {
    const link = new URL(event.htmlLink);
    const eid = link.searchParams.get('eid');
    url = `https://calendar.google.com/calendar/u/0/r/eventedit/${eid}`;
  } else if (event?.provider === 'microsoft') {
    // Graph webLink already points at the correct Outlook host for the account type.
    if (event.htmlLink) {
      window.open(event.htmlLink, '_blank', 'noopener,noreferrer');
      return;
    }

    const host = getOutlookWebHost(microsoftEmail);
    const openOutlookEdit = (idToUse: string) => {
      const encoded = encodeURIComponent(idToUse);
      window.open(`https://${host}/calendar/item/${encoded}`, '_blank', 'noopener,noreferrer');
    };

    if (!microsoftAccessToken) {
      openOutlookEdit(event.id);
      return;
    }

    void (async () => {
      const owaId = await translateMicrosoftRestIdToOwaId(event.id, microsoftAccessToken);
      openOutlookEdit(owaId ?? event.id);
    })();
    return;
  }

  if (url) {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
};
